const SELECTOR = '[data-direct-checkout]';

document.addEventListener('click', async (event) => {
  const button = event.target.closest(SELECTOR);
  if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

  const productForm = button.closest('product-form-component');
  const form = productForm?.querySelector('form[action*="/cart/add"]');
  const label = button.querySelector('[data-direct-checkout-label]');
  const liveRegion = productForm?.querySelector('[ref="liveRegion"]');

  if (!form) return;

  const originalLabel = label?.textContent || 'Buy now';
  button.setAttribute('aria-busy', 'true');
  button.disabled = true;
  if (label) label.textContent = 'Opening checkout…';

  try {
    const response = await fetch(button.dataset.cartAddUrl, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || error.message || 'Unable to add this item.');
    }

    window.location.assign(button.dataset.checkoutUrl || '/checkout');
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unable to open checkout. Please try again.';
    if (liveRegion) liveRegion.textContent = message;
    if (label) label.textContent = 'Try again';
    button.removeAttribute('aria-busy');
    button.disabled = false;

    window.setTimeout(() => {
      if (label) label.textContent = originalLabel;
      if (liveRegion) liveRegion.textContent = '';
    }, 3000);
  }
});
